import { Badge, BadgeVariants, BadgeSizes, TableCellTypes } from '@carboledger/ui';
import { CellText, makeUnitTypeCell, makeUnitScopedCell } from '@/components/common';
import { buildRowUnitOptions, unitTypeLabel } from './declarationUnits';
import { MASS_BALANCE_PERIOD_STATUS } from './declarations.constants';

// The Overview tab's "Mass balance period details" — the chain of one declaration's balances.
const renderUnitTypeCell = makeUnitTypeCell((t, row) => buildRowUnitOptions(t, row.byUnit));
const renderOpeningBalance = makeUnitScopedCell('openingBalance');
const renderInboundQty = makeUnitScopedCell('inboundQty');
const renderSurplusQty = makeUnitScopedCell('surplusQty');
const renderWriteOffQty = makeUnitScopedCell('writeOffQty');
const renderAllocatedQty = makeUnitScopedCell('allocatedQty');
const renderClosingBalance = makeUnitScopedCell('closingBalance');

/**
 * Props:
 *   row  the mass balance period row view model
 *   t    the builder's translator, as the sibling columns files pass it
 */
const PeriodNameCell = ({ row, t }) => (
  <>
    <CellText>{row.name}</CellText>
    {row.statusCode === MASS_BALANCE_PERIOD_STATUS.open && (
      <Badge variant={BadgeVariants.primary} size={BadgeSizes.sm}>
        {t('DECLARATIONS_PERIOD_CURRENT')}
      </Badge>
    )}
  </>
);

export const buildMassBalancePeriodColumns = (t, { unitHeaderSelect }) => [
  {
    id: 'serialNo',
    header: t('FIELD_SERIAL_NO'),
    type: TableCellTypes.text,
    width: 60,
  },
  {
    id: 'name',
    header: t('FIELD_MASS_BALANCE_PERIOD_NAME'),
    type: TableCellTypes.custom,
    width: 160,
    cell: (ctx) => <PeriodNameCell row={ctx.row} t={t} />,
  },
  {
    id: 'period',
    header: t('FIELD_PERIOD'),
    type: TableCellTypes.text,
    width: 170,
  },
  {
    id: 'unitType',
    header: t('FIELD_UNIT_TYPE', { unit: unitTypeLabel(t, unitHeaderSelect.value) }),
    type: TableCellTypes.custom,
    width: 252,
    cell: renderUnitTypeCell,
    headerSelect: unitHeaderSelect,
  },
  {
    id: 'openingBalance',
    header: t('FIELD_OPENING_QUANTITY'),
    type: TableCellTypes.custom,
    width: 120,
    cell: renderOpeningBalance,
  },
  {
    id: 'inboundQty',
    header: t('FIELD_INBOUND_QUANTITY'),
    type: TableCellTypes.custom,
    width: 120,
    cell: renderInboundQty,
  },
  {
    id: 'surplusQty',
    header: t('DECLARATIONS_COL_SURPLUS_QTY'),
    type: TableCellTypes.custom,
    width: 120,
    cell: renderSurplusQty,
  },
  {
    id: 'writeOffQty',
    header: t('DECLARATIONS_COL_WRITE_OFF_QTY'),
    type: TableCellTypes.custom,
    width: 120,
    cell: renderWriteOffQty,
  },
  {
    id: 'allocatedQty',
    header: t('FIELD_ALLOCATED_QUANTITY'),
    type: TableCellTypes.custom,
    width: 120,
    cell: renderAllocatedQty,
  },
  {
    id: 'closingBalance',
    header: t('FIELD_CLOSING_BALANCE'),
    type: TableCellTypes.custom,
    width: 120,
    cell: renderClosingBalance,
  },
];
